import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, map, switchMap, exhaustMap, catchError, take, delay, first, mergeMap } from 'rxjs/operators';
import { get as _get } from 'lodash';
import { CrmUser, CrmUserRole } from '@app-models/index';
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
@Injectable()
export class CrmLanguagesService {
	public crmUserRoles: CrmUserRole[];
	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
	) {
	}
	getAllCrmLanguages() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		const api = APIs.crm_languages;
		return this._httpClient.get(api, { headers: headers });
	}
	getCrmLanguages(id: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_languages;
		if (id)
			api += '/' + id;
		return this._httpClient.get(api, { headers: headers });
	}
	insertCrmLanguage(body: CrmUser) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_languages, body, { headers: headers });
	}
	updateCrmLanguage(body: any, id: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_languages + '/' + id, body, { headers: headers });
	}
	updateCrmLanguagestranslation(body: any, id: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_languages + '/transaltion/' + id, body, { headers: headers });
	}
	updateCrmLanguagesCrmTranslation(body: any, id: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_languages + '/crmTranslation/' + id, body, { headers: headers });
	}
	deleteCrmLanguage(id: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !id)
			return of(null);
		const api = `${APIs.crm_languages}/${id}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	addPhrase(phrase: string, category: string) {
		const body = { phrase, category };
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_languages + '/addPhrase', body, { headers: headers });
	}
}
